import { Component, OnInit } from '@angular/core';
import { VersionCheckService } from './service/version-check.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import  PackageJson from '../../package.json';
import { PrimeNGConfig } from 'primeng/api';
import { ServiceStructService } from './service/service-struct.service';
import { RouteService, StructService } from './util/structService/struct-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'nexus-ng-web-cliente';
  API_KEY:any

  constructor(
    private versionCheckService: VersionCheckService,
    private cookieService: CookieService,
    private primengConfig: PrimeNGConfig,
    private appServiceComponent: ServiceStructService,
  ) { }
  async ngOnInit() {
    environment.VERSION = PackageJson.version

    var data = await this.appServiceComponent.requestService(StructService.CODE, RouteService.GetKeyGoogle, {})
    this.API_KEY= data.KEY.KEY

    this.loadScript(this.API_KEY)

    this.versionCheckService.initVersionCheck(environment.versionCheckURL)
    this.primengConfig.ripple = true;
  }

   loadScript(name: string) {
   const existingScript = document.querySelector(`script[src*="maps.googleapis.com"]`);

    if (existingScript) {
      console.warn("Eliminando script existente de Google Maps para recargar con nueva clave...");
      existingScript.remove(); // Eliminar el script anterior
      (window as any).google = undefined; // Resetear la API de Google
    } 
    console.log(name)
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${name}&libraries=drawing,geometry,places`;
    script.async = true;
    script.defer = true;
    script.setAttribute("loading", "async")
    document.head.appendChild(script);
  }
}
